// 四大创新功能 API
const mpPalaceMyList = '/api/mp/palace/myList'
const mpTemplateList = '/api/mp/template/list'
const mpPalaceStats = '/api/mp/palace/stats'
const mpPalaceCreate = '/api/mp/palace/create'
const mpPalaceCreateFromBook = '/api/mp/palace/createFromBook'
const mpPalaceDetail = '/api/mp/palace/detail'
const mpPalaceUpdate = '/api/mp/palace/update'
const mpAnchorList = '/api/mp/anchor/list'
const mpAnchorBind = '/api/mp/anchor/bind'
const mpAnchorDetail = '/api/mp/anchor/detail'
const mpAnchorUpdate = '/api/mp/anchor/update'
const mpAnchorSuggestion = '/api/mp/anchor/suggestion'
const mpReviewStart = '/api/mp/review/start'
const mpReviewSubmit = '/api/mp/review/submit'
const mpReviewFinish = '/api/mp/review/finish'
const mpReviewResult = '/api/mp/review/result'
const mpReviewAddWrong = '/api/mp/review/addToWrongBook'
const mpTestGenerate = '/api/mp/test/generate'
const mpTestSubmit = '/api/mp/test/submit'
const mpWordSearch = '/api/mp/word/search'
const mpImageMyList = '/api/mp/image/myList'
const mpImageSave = '/api/mp/image/save'
const mpImageSystem = '/api/mp/image/system'
const mpImageFavorite = '/api/mp/image/favorite'
const mpShareCreate = '/api/mp/share/create'
const mpShareInfo = '/api/mp/share/info'

const cpSceneDaily = '/api/cp/scene/daily'
const cpSceneList = '/api/cp/scene/list'
const cpSceneStats = '/api/cp/scene/stats'
const cpSceneDetail = '/api/cp/scene/detail'
const cpPuzzleStart = '/api/cp/puzzle/start'
const cpPuzzleFinish = '/api/cp/puzzle/finish'
const cpPuzzleResult = '/api/cp/puzzle/result'
const cpCardGenerate = '/api/cp/card/generate'
const cpCardDetail = '/api/cp/card/detail'
const cpCardShare = '/api/cp/card/share'
const cpCardMyList = '/api/cp/card/myList'
const cpSceneNext = '/api/cp/scene/next'

const etTreeMyList = '/api/et/tree/myList'
const etRootList = '/api/et/root/list'
const etForestStats = '/api/et/tree/forestStats'
const etTreeCreate = '/api/et/tree/create'
const etTreeDetail = '/api/et/tree/detail'
const etTreeLeaves = '/api/et/tree/leaves'
const etTreeDynamics = '/api/et/tree/dynamics'
const etTreeInvite = '/api/et/tree/invite'
const etTreeMembers = '/api/et/tree/members'
const etTreeMemberRemove = '/api/et/tree/member/remove'
const etRootDetail = '/api/et/root/detail'
const etRootProgress = '/api/et/root/progress'
const etJoinInfo = '/api/et/tree/join/info'
const etTreeJoin = '/api/et/tree/join'
const etTreeWater = '/api/et/tree/water'
const etTreeMessages = '/api/et/tree/messages'
const etTreeMessageSend = '/api/et/tree/message/send'

const slContestList = '/api/sl/contest/list'
const slContestHot = '/api/sl/contest/hot'
const slContestDetail = '/api/sl/contest/detail'
const slTeamCreate = '/api/sl/team/create'
const slTeamJoin = '/api/sl/team/join'
const slTeamDetail = '/api/sl/team/detail'
const slStorySubmit = '/api/sl/story/submit'
const slStoryList = '/api/sl/story/list'
const slVote = '/api/sl/vote'
const slComment = '/api/sl/comment'
const slRanking = '/api/sl/contest/ranking'
const slSentenceCollect = '/api/sl/sentence/collect'
const slSentenceCollections = '/api/sl/sentence/collections'
const slUserStats = '/api/sl/user/stats'

export default {
  mpPalaceMyList, mpTemplateList, mpPalaceStats, mpPalaceCreate, mpPalaceCreateFromBook, mpPalaceDetail, mpPalaceUpdate,
  mpAnchorList, mpAnchorBind, mpAnchorDetail, mpAnchorUpdate, mpAnchorSuggestion,
  mpReviewStart, mpReviewSubmit, mpReviewFinish, mpReviewResult, mpReviewAddWrong,
  mpTestGenerate, mpTestSubmit, mpWordSearch,
  mpImageMyList, mpImageSave, mpImageSystem, mpImageFavorite, mpShareCreate, mpShareInfo,
  cpSceneDaily, cpSceneList, cpSceneStats, cpSceneDetail,
  cpPuzzleStart, cpPuzzleFinish, cpPuzzleResult,
  cpCardGenerate, cpCardDetail, cpCardShare, cpCardMyList, cpSceneNext,
  etTreeMyList, etRootList, etForestStats, etTreeCreate, etTreeDetail,
  etTreeLeaves, etTreeDynamics, etTreeInvite, etTreeMembers, etTreeMemberRemove,
  etRootDetail, etRootProgress, etJoinInfo, etTreeJoin, etTreeWater,
  etTreeMessages, etTreeMessageSend,
  slContestList, slContestHot, slContestDetail, slTeamCreate, slTeamJoin,
  slTeamDetail, slStorySubmit, slStoryList, slVote, slComment, slRanking,
  slSentenceCollect, slSentenceCollections, slUserStats
}



// WEBPACK FOOTER //
// ./src/utils/innovationApi.js